import { render, staticRenderFns } from "./SalesComponent.vue?vue&type=template&id=ff56fb5e&scoped=true&"
import script from "./SalesComponent.vue?vue&type=script&lang=ts&"
export * from "./SalesComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SalesComponent.vue?vue&type=style&index=0&id=ff56fb5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff56fb5e",
  null
  
)

export default component.exports